export default "__VITE_ASSET__Biyy5W9___"